"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_kb_api_1 = require("@synisys/skynet-store-kb-api");
var skynet_store_manager_1 = require("@synisys/skynet-store-manager");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var operators_1 = require("rxjs/operators");
var kb_utilities_1 = require("../kb.utilities");
var LOGGER = kb_utilities_1.createLogger('kb-reload.service');
var KbReloadService = /** @class */ (function () {
    function KbReloadService(store, notifier) {
        this.store = store;
        this.notifier = notifier;
    }
    KbReloadService.prototype.init = function () {
        var _this = this;
        this.notifier.subscribe('kb-service', 'kb-partial-refresh').subscribe(function (data) {
            var messagingData = JSON.parse(data);
            var prefix = messagingData.data.prefix
                ? messagingData.data.prefix
                : skynet_store_kb_api_1.defaultKbKey;
            _this.reloadByCategory(prefix, messagingData.data.categories.filter(function (c) { return messagingData.data.changes[c] === 'UPDATE'; }));
            _this.eraseCategories(prefix, new Set(messagingData.data.categories.filter(function (c) { return messagingData.data.changes[c] === 'DELETE'; })));
        }, function (err) { return LOGGER.error(err); });
    };
    KbReloadService.prototype.reloadByCategory = function (prefix, categories) {
        var _this = this;
        this.store
            .select(skynet_store_kb_api_1.kbFeatureKey)
            .pipe(operators_1.first(), operators_1.filter(function (state) { return skynet_store_utilities_1.notNil(state.categories[prefix]); }))
            .subscribe(function (state) {
            categories.forEach(function (category) {
                if (lodash_1.get(state.categories, prefix, immutable_1.List()).find(function (metaCategory) {
                    return metaCategory.metaCategoryId.systemName ===
                        category;
                })) {
                    _this.store.dispatch(skynet_store_kb_api_1.categoryStoreManager(prefix).createAction(skynet_store_manager_1.StandardActionTypes.LOAD_ONE, category));
                }
                if (state.fields[prefix].has(category)) {
                    _this.store.dispatch(skynet_store_kb_api_1.groupStoreManager(prefix).createAction(skynet_store_manager_1.StandardActionTypes.LOAD_ALL, category));
                }
                if (state.groups[prefix].has(category)) {
                    _this.store.dispatch(skynet_store_kb_api_1.fieldStoreManager(prefix).createAction(skynet_store_manager_1.StandardActionTypes.LOAD_ALL, category));
                }
            });
        }, function (err) { return LOGGER.error(err); });
    };
    KbReloadService.prototype.eraseCategories = function (prefix, categories) {
        var _this = this;
        this.store
            .select(skynet_store_kb_api_1.kbFeatureKey)
            .pipe(operators_1.first(), operators_1.filter(function (state) { return skynet_store_utilities_1.notNil(state.categories[prefix]); }))
            .subscribe(function (state) {
            lodash_1.get(state.categories, prefix, immutable_1.List())
                .filter(function (category) {
                return categories.has(category.metaCategoryId.systemName);
            })
                .forEach(function (category) {
                _this.store.dispatch(skynet_store_kb_api_1.categoryStoreManager(prefix).createAction(skynet_store_manager_1.StandardActionTypes.DELETE_SUCCESS, category));
            });
        }, function (err) { return LOGGER.error(err); });
    };
    return KbReloadService;
}());
exports.KbReloadService = KbReloadService;
var kbReloadService;
function kbReloadServiceFactory(store) {
    var notifierEventSourceServiceFactory;
    try {
        notifierEventSourceServiceFactory = require('@synisys/skynet-store-client-notifier')
            .notifierEventSourceServiceFactory;
    }
    catch (e) {
        LOGGER.warn('cannot import @synisys/idm-client-notifier-js or @synisys/skynet-store-client-notifier, %O', e);
        return undefined;
    }
    if (!kbReloadService && notifierEventSourceServiceFactory) {
        kbReloadService = new KbReloadService(store, notifierEventSourceServiceFactory(store));
        kbReloadService.init();
    }
    return kbReloadService;
}
exports.kbReloadServiceFactory = kbReloadServiceFactory;
//# sourceMappingURL=_kb-reload.service.js.map